import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-read-only-info-dialog',
  templateUrl: './read-only-info-dialog.component.html',
  styleUrls: ['./read-only-info-dialog.component.scss']
})
export class ReadOnlyInfoDialogComponent {
}
